import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Finger({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Finger</title>
      <path
        d="M8.59542 20.0512C7.38187 18.3194 6.66797 16.2124 6.66797 13.9373C6.66797 10.991 9.05505 8.60303 11.9996 8.60303C14.9441 8.60303 17.3312 10.991 17.3312 13.9373"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.59542 20.0512C7.38187 18.3194 6.66797 16.2124 6.66797 13.9373C6.66797 10.991 9.05505 8.60303 11.9996 8.60303C14.9441 8.60303 17.3312 10.991 17.3312 13.9373"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6197 19.257C17.5237 19.2624 17.4295 19.2713 17.3326 19.2713C14.3881 19.2713 12.001 16.8833 12.001 13.937"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6197 19.257C17.5237 19.2624 17.4295 19.2713 17.3326 19.2713C14.3881 19.2713 12.001 16.8833 12.001 13.937"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1086 20.7315C10.8433 19.3188 9.33461 16.8046 9.33461 13.9374C9.33461 12.4643 10.5286 11.2703 12.0009 11.2703C13.4731 11.2703 14.6671 12.4643 14.6671 13.9374C14.6671 15.4106 15.8611 16.6046 17.3333 16.6046C18.8056 16.6046 19.9996 15.4106 19.9996 13.9374C19.9996 9.51799 16.4185 5.93604 12.0017 5.93604C7.58497 5.93604 4.00391 9.51799 4.00391 13.9374C4.00391 14.9225 4.11415 15.8818 4.31685 16.8064"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1086 20.7315C10.8433 19.3188 9.33461 16.8046 9.33461 13.9374C9.33461 12.4643 10.5286 11.2703 12.0009 11.2703C13.4731 11.2703 14.6671 12.4643 14.6671 13.9374C14.6671 15.4106 15.8611 16.6046 17.3333 16.6046C18.8056 16.6046 19.9996 15.4106 19.9996 13.9374C19.9996 9.51799 16.4185 5.93604 12.0017 5.93604C7.58497 5.93604 4.00391 9.51799 4.00391 13.9374C4.00391 14.9225 4.11415 15.8818 4.31685 16.8064"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4446 6.64159C17.6265 4.57634 14.9682 3.26855 12.0006 3.26855C9.03298 3.26855 6.37474 4.57634 4.55664 6.64159"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4446 6.64159C17.6265 4.57634 14.9682 3.26855 12.0006 3.26855C9.03298 3.26855 6.37474 4.57634 4.55664 6.64159"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
